import { getPopularityHealthStats } from 'state/utils';
import {
    getMetricValue,
    normalizeBreakout,
    parseMetrics,
} from './parseMetrics';
import { buildBreadcrumb } from './breadcrumbFormat';
import { growthTone } from './metricTone';
import type { CardModel, EntityDataOutput, MetricRow } from '../types';

export function buildCardModel(
    output: EntityDataOutput,
    typeLabel: string,
): CardModel | null {
    const result = output?.result;
    // Prefer the lens-independent `_card_metrics` (attached on every self call);
    let snapshot: MetricRow;
    if (output?._card_metrics != null) {
        snapshot = output._card_metrics;
    } else if (Array.isArray(result?.metrics)) {
        snapshot = parseMetrics(result.metrics);
    } else {
        throw new Error(
            `inline card (${typeLabel}): expected _card_metrics or a ` +
                `result.metrics array on the get_entity_data output`,
        );
    }
    if (Object.keys(snapshot).length === 0) return null;
    const entity = output?._entity;
    const title = entity?.name || typeLabel;
    const clusterValue = getMetricValue(snapshot, 'Trend Cluster');
    const yoyDisplay =
        normalizeBreakout(getMetricValue(snapshot, 'YoY')) ?? null;
    const healthStats = getPopularityHealthStats(output?._snapshot);
    const popularityLabel =
        healthStats?.['average monthly popularity']?.scoreLabel || 'Popularity';
    const predictedScoreLabel =
        healthStats?.['popularity predicted growth']?.scoreLabel;
    const predictedYoyLabel = predictedScoreLabel
        ? `${predictedScoreLabel} Predicted YoY`
        : 'Predicted YoY';

    return {
        breadcrumb: buildBreadcrumb(output, typeLabel),
        title,
        link: result?.dashboard_url,
        lifeCycle: getMetricValue(snapshot, 'Life Cycle'),
        timeSeries: output?._time_series,
        tiles: [
            {
                label: popularityLabel,
                value: getMetricValue(snapshot, 'Popularity') ?? null,
            },
            {
                label: 'YoY',
                value: yoyDisplay,
                tone: growthTone(yoyDisplay),
            },
            {
                label: predictedYoyLabel,
                value:
                    normalizeBreakout(
                        getMetricValue(snapshot, 'Predicted YoY'),
                    ) ?? null,
            },
            {
                label: 'Cluster',
                value: clusterValue ?? '—',
            },
        ],
    };
}
